export default __webpack_public_path__ + "static/media/dolar.df5ac114.svg";